import { api } from "./api";

export const apiFeedback = {
  getFeedbacks: (page, size = 10) => api.get("web/feedbacks", { page, size }),

  createFeedback: (content) => api.post("web/feedbacks/create", { content }),

  getFeedBackByUser: (page = 1) =>
    api.get(`web/feedbacks/mine?page=${page}&size=10`),
};
